export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9413.7bb60ad5.jpg";